import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Checkbox } from 'ui-components/components/checkbox/';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuTitleWithLabel } from 'ui-components/components/dropdown-menu-title-with-label';
import { Input } from 'ui-components/components/input';
import { noop } from 'ui-components/default-props/noop';
import { FormattedMessagePropType } from '../../../../prop-types/intl';

import style from './inputs.module.css';
import { emptyObject } from 'ui-components/default-props/empty';

const options = [
  {
    id: 'Ounces',
    label: <FormattedMessage defaultMessage='Ounces' description='otherShippingOptions.ounces' id='JPk9h2' />,
  },
  {
    id: 'Grams',
    label: <FormattedMessage defaultMessage='Grams' description='otherShippingOptions.grams' id='l4tMyI' />,
  },
];
const unitLabel = <FormattedMessage defaultMessage='Weight Unit' description='otherShippingOptions.dryIceUnit' id='ZxgfHP' />;
const weightLabel = <FormattedMessage defaultMessage='Weight' description='otherShippingOptions.dryIceWeight' id='pgCdq7' />;

const updateDryIceValue = (field, value, data, updateOption) => {
  const newValue = {
    ...data,
    weight: {
      ...data.weight,
      [field]: value,
    },
  };
  updateOption({ id: 'dryIce', value: newValue });
};

const renderDryIceInput = (data, updateOption, updateInput) => {
  const { weight } = data;
  if (!weight) {
    return null;
  }
  return (
    <div className={style['other-input']}>
      <Input label={weightLabel} onBlur={(v) => updateOption('value', v)} onChange={(v) => updateInput('value', v)} value={weight.value} />
      <DropdownMenu>
        <DropdownMenuToggler>
          <DropdownMenuTitleWithLabel label={unitLabel} title={weight.unit} />
        </DropdownMenuToggler>
        {options.map((option) => (
          <DropdownMenuItem key={option.id} onClick={() => updateOption('unit', option.id)}>
            {option.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenu>
    </div>
  );
};

export const DryIceInput = ({
  label,
  checked = false,
  optionData = emptyObject,
  onCheck = noop,
  updateOption = noop,
  updateInput = noop,
}) => (
  <div>
    <Checkbox checked={checked} label={label} onChange={onCheck} />
    {optionData &&
      checked &&
      renderDryIceInput(
        optionData,
        (field, value) => updateDryIceValue(field, value, optionData, updateOption),
        (field, value) => updateDryIceValue(field, value, optionData, updateInput),
      )}
  </div>
);

DryIceInput.propTypes = {
  label: FormattedMessagePropType.isRequired,
  checked: PropTypes.bool,
  onCheck: PropTypes.func,
  optionData: PropTypes.object,
  updateOption: PropTypes.func,
  updateInput: PropTypes.func,
};
